import axios from "axios";
import { config } from "../config";

export class LegalsService {
  /*********** List ***********/
  public list = async (): Promise<any> => {
    try {
      const { serverUrl } = config;
      const response = await axios.get(serverUrl + "legals");
      return response.data;
    } catch (error) {
      return { message: "error" };
    }
  };
}
